
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

export default function MarketingAdvertising() {
  const [isVisible, setIsVisible] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = 'Marketing & Advertising Commercial Outcomes - Negotrix | 15-25% Improvement';
    setTimeout(() => setIsVisible(true), 100);
  }, []);

  return (
    <div className={`min-h-screen bg-cipher-black text-white transition-opacity duration-700 ${isVisible ? 'opacity-100' : 'opacity-0'}`}>
      <Header />

      {/* Hero */}
      <section className="pt-40 pb-24 px-6 lg:px-12">
        <div className="max-w-[1400px] mx-auto">
          <h2 className="text-sm tracking-widest uppercase text-cipher-hypergreen font-bold mb-6">Cost Category</h2>
          <h1 className="text-[8vw] leading-[0.9] font-black tracking-tighter mb-12">
            <span className="text-white">Marketing &</span><br />
            <span className="text-cipher-hypergreen">Advertising.</span>
          </h1>
          <div className="flex items-center gap-6 mb-10">
            <div className="text-5xl font-black text-cipher-hypergreen">30–50%</div>
              <div className="text-gray-400 text-xl">average marketing<br />waste improved</div>
          </div>
          <p className="text-xl text-gray-400 max-w-2xl">
            Eliminate wasted ad spend, improve channel strategy, and strengthen ROI tracking across all marketing activities without reducing output.
          </p>
        </div>
      </section>

      {/* What We Do */}
      <section className="py-24 bg-cipher-dark border-t border-gray-900">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
          <h2 className="text-sm tracking-widest uppercase text-cipher-hypergreen font-bold mb-16">What We Do</h2>
          <div className="border-t border-gray-800">
            {[
               { title: 'Ad Spend Analysis & Waste Elimination', desc: 'We audit every paid channel to identify underperforming campaigns, duplicate targeting, and budget allocated to zero-ROI activities, often finding 25–40% is wasted.' },
              { title: 'Channel Performance Optimization', desc: 'We benchmark your channel mix against industry data and reallocate budget from low-performing channels to the ones generating the highest returns for your business.' },
              { title: 'MarTech Stack Consolidation', desc: 'We identify overlapping marketing tools, consolidate your tech stack, and renegotiate agency and platform fees using current market benchmarks.' },
              { title: 'Agency & Media Vendor Renegotiation', desc: 'We use your performance data and industry benchmarks to renegotiate agency retainers, media buying fees, and platform costs.' },
            ].map((item, i) => (
              <div key={i} className="group border-b border-gray-800 py-12 hover:bg-cipher-black transition-colors px-6 -mx-6">
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 items-start">
                  <div className="lg:col-span-1 text-gray-600 font-black text-xl">0{i + 1}</div>
                  <div className="lg:col-span-4 text-2xl lg:text-3xl font-black group-hover:text-cipher-hypergreen transition-colors">{item.title}</div>
                  <div className="lg:col-span-7 text-gray-400 text-lg">{item.desc}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Stats */}
      <section className="py-24 bg-cipher-black border-t border-gray-900">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {[
              { val: 'Direct', label: 'Vendor Negotiation' },
              { val: 'No', label: 'Upfront Fees' },
              { val: 'Only', label: 'On Results' }
            ].map((s, i) => (
              <div key={i} className="p-8 bg-cipher-dark rounded-[2rem] border border-gray-800">
                <div className="text-5xl lg:text-6xl font-black text-cipher-hypergreen mb-4">{s.val}</div>
                <div className="text-sm tracking-widest uppercase text-gray-500 font-bold">{s.label}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-32 lg:py-48 bg-cipher-dark border-t border-gray-800">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-12 text-center">
          <h2 className="text-[8vw] leading-[0.9] font-black tracking-tighter text-white mb-12">
            Make every<br /><span className="text-cipher-hypergreen">dollar count.</span>
          </h2>
          <button
            onClick={() => navigate('/contact')}
            className="inline-flex items-center justify-center px-10 py-5 text-lg tracking-wide font-bold uppercase rounded-full text-cipher-black bg-cipher-hypergreen hover:bg-white transition-all duration-300"
          >
             Start Your Commercial Review
          </button>
        </div>
      </section>

      <Footer />
    </div>
  );
}
